import React from 'react'

const Gear = ({ scrollY }) => {
  const rotation = (scrollY / 30) % 360
  const style = { transform: `rotate(${rotation}deg)` }
  return <div className="gear" style={style} />
}

export default Gear
